"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetSubordinates = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const subordinateKeys_1 = __importDefault(require("consts/queryKeys/subordinateKeys"));
const useGetSubordinates = (type, userId, params, options) => {
    const fetchSubordinates = (type, olderThan) => {
        return type == 'direct'
            ? (0, ObjectivesClient_1.getFormerDirectReport)(userId, { ...params, olderThan })
            : (0, ObjectivesClient_1.getFormerInDirectReport)(userId, { ...params, olderThan });
    };
    return (0, react_query_1.useInfiniteQuery)(subordinateKeys_1.default.subordinates(type, params), ({ pageParam }) => fetchSubordinates(type, pageParam), {
        getNextPageParam: lastPage => {
            return lastPage?.pagination?.next?.olderThan;
        },
        ...options
    });
};
exports.useGetSubordinates = useGetSubordinates;
